
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * A hook that updates the canonical link tag based on the current route
 */
export const useCanonical = () => {
  const location = useLocation();
  const baseUrl = 'https://portal.eosydney.com.au';
  
  useEffect(() => {
    // Get the canonical link element or create one if it doesn't exist
    let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    
    if (!link) {
      link = document.createElement('link');
      link.rel = 'canonical';
      document.head.appendChild(link);
    }
    
    // Set the href to the base URL + current path
    link.href = `${baseUrl}${location.pathname}`;
  }, [location.pathname]);
};
